import { Box, Typography, Stack, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
const ContentLayout = (
  { children, title, description, actions, backLink }: { children: React.ReactNode; title?: string; description?: string; actions?: { label: string; to?: string; onClick?: () => void }[]; backLink?: { label: string; to: string } }
) => {
  return (
    <>
      {/* Page header */}
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        sx={{ 
          mb: 4, 
          justifyContent: 'space-between',
          alignItems: 'flex-start'
        }}
      >
        <Stack sx={{ alignItems: 'flex-start', mb:2 }} direction="column">
          {backLink && (
            <Link to={backLink.to} style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 3,
            fontSize: '0.75rem',
          }}>
            <ArrowBackIcon sx={{
              fontSize: '1rem',
            }} /> {backLink.label || 'Back'}
          </Link>
          )}
          {title && (<Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>{title}</Typography>)}
          {description && (<Typography variant="body2" color="text.secondary">{description}</Typography>)}
        </Stack>
        {actions && actions.length > 0 && (
          <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: 'wrap' }}>
            {actions.map((action) => (
              <Button
                key={action.to || action.label}
                {...(action.to ? { component: Link, to: action.to } : {})}
                {...(action.onClick ? { onClick: action.onClick } : {})}
                variant="contained"
              >
                {action.label}
              </Button>
            ))}
          </Stack>
        )}
      </Stack>
      {children}
    </>
  );
};

export default ContentLayout;